/**
 * MTA product page helpers.
 *
 * <mta-stock-bar> — mirrors Dwell's assets/product-inventory.js: on the
 * section-level `productSelect` event (dispatched by the variant picker), the
 * theme fetches the re-rendered section via the Section Rendering API and
 * resolves `event.promise` with `{ detail: { html } }`. We pick our block out
 * of that document and morph it in place (attributes + children), so the
 * status / bar width / hidden state follow the selected variant.
 */
import { morph } from '@theme/morph';
import { StandardEvents } from '@shopify/events';

class MtaStockBar extends HTMLElement {
  /** @type {Element | null} */
  #target = null;

  connectedCallback() {
    this.#target = this.closest('.shopify-section, dialog');
    this.#target?.addEventListener(StandardEvents.productSelect, this.#handleProductSelect);
  }

  disconnectedCallback() {
    this.#target?.removeEventListener(StandardEvents.productSelect, this.#handleProductSelect);
    this.#target = null;
  }

  /** @param {any} event */
  #handleProductSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    event.promise
      ?.then(({ detail }) => {
        if (!detail?.html) return;

        const { html, newProduct } = detail;

        if (newProduct) {
          this.dataset.productId = newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const fresh = html.querySelector('mta-stock-bar');
        if (!fresh) return;

        morph(this, fresh);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[mta-stock-bar] Event promise rejected:', error);
      });
  };
}

if (!customElements.get('mta-stock-bar')) {
  customElements.define('mta-stock-bar', MtaStockBar);
}
